import { TThreeUtpBlock } from 'shared/types/utp';

export const UTP: TThreeUtpBlock = [
  {
    color: 'dark-gray',
    title: 'Арендаторам',
    description: 'Верификация через Госуслуги, временная регистрация онлайн, договор по шаблону, одобренному юристами',
  },
  {
    color: 'light-blue',
    title: 'Собственникам',
    description:
      'Подтверждённая личность арендатора, гарантия законности сделки, регистрация жильцов без визитов в МФЦ',
  },
  {
    color: 'blue',
    title: 'Риелторам',
    description:
      'Верификация обеих сторон через Госуслуги, меньше бюрократии, рост ценности объектов в работе с клиентами',
  },
];
